import { Link, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import Swal from "sweetalert2";
import { createCustomerSocialReason } from "../../../../services/CatalogService";
import CustomerSocialReasonFields from "./formCustomerSocialReason/customerSocialReasonFields";
import {
  customerSocialReasonValidationSchema,
  customerSocialReasonInitialValues,
} from "./formCustomerSocialReason/customerSRFormConfig";
import { useEffect } from "react";

function VaroExpressNewCustomerSocialR() {
  const razonSocial = 'VaroExpress';

  
  const navigate = useNavigate();
  const { Formik } = formik;
  function AutoValidateOnMount({ setTouched, validateForm }) {
    useEffect(() => {
      const allFieldsTouched = Object.keys(customerSocialReasonInitialValues).reduce(
        (acc, key) => ({ ...acc, [key]: true }),
        {}
      );
      setTouched(allFieldsTouched, true);
      validateForm();
    }, [setTouched, validateForm]);

    return null;
  }
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/billing-VaroExpress/CustomerSocialReason">
                Clientes razón social - Varo Express
              </Link>
            </li>
            <li className="breadcrumb-item active">Nuevo Cliente</li>
          </ol>
          <h1 className="page-header mb-0">Registrar nuevo cliente - Varo Express</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de nuevo cliente</PanelHeader>
            <PanelBody>
              <Formik
                 validationSchema={customerSocialReasonValidationSchema}
                 initialValues={customerSocialReasonInitialValues}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    const payload = {
                      ...values,
                      fiscalRegimeId:
                        values.fiscalRegimeId?.id?.toString() || null,
                      cfdiId: values.cfdiId?.id?.toString() || null,
                      name: values.name ? values.name.trimEnd() : values.name,

                    };

                    //console.log(payload); // Verifica que los IDs son strings

                    await createCustomerSocialReason(payload, razonSocial);

                    Swal.fire({
                      title: "Registro exitoso",
                      text: "Se ha registrado el nuevo cliente",
                      icon: "success",
                      confirmButtonText: "Cerrar",
                    });

                    navigate("/billing-VaroExpress/CustomerSocialReason");
                  } catch (err) {
                    Swal.fire({
                      title: "Ups!",
                      text: err.response?.data?.message || "Error al registrar",
                      icon: "error",
                      confirmButtonText: "Cerrar",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  setTouched,      
                  validateForm 
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                     <AutoValidateOnMount
                      setTouched={setTouched}
                      validateForm={validateForm}
                    />                                 
                    <CustomerSocialReasonFields
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={(field, value) => {
                        if (["fiscalRegimeId", "cfdiId"].includes(field)) {
                          if (!value || Object.keys(value).length === 0) {
                            values[field] = null;
                          } else {
                            values[field] = value;
                          }
                        } else {
                          values[field] = value;
                        }
                      }}
                    />

                    <Row className="mb-3">
                        <Col md="12" className="text-end">
                        <Button type="submit">Guardar Cliente</Button>{" "}
                        <Link
                          to="/billing-VaroExpress/CustomerSocialReason"
                          className="btn btn-info"
                        >
                          Cancelar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default VaroExpressNewCustomerSocialR;
